import browserInfo from './browser';
import { EcoType } from '../const/enums';
/**
 * 当前环境对应的生态类型
 */

export var ecoType = [EcoType.dingTalk, EcoType.fs, EcoType.qywx, EcoType.wx].find(function (type) {
  return browserInfo[type];
});
/**
 * 当前环境相关信息，浏览器相关
 */

export var browser = browserInfo;